/**
 * Environment variables for Vite
 * Access via import.meta.env.VITE_*
 */

// Helper to get env var with validation
function getEnvVar(key: string, required: boolean = false): string | undefined {
  const value = import.meta.env[key];
  if (required && !value) {
    console.error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const env = {
  // Django API (required for authentication)
  NEXT_PUBLIC_DJANGO_API_BASE_URL: getEnvVar('VITE_DJANGO_API_BASE_URL', false) || '',

  // Fireblocks API (optional)
  NEXT_PUBLIC_FIREBLOCKS_API_BASE_URL: getEnvVar('VITE_FIREBLOCKS_API_BASE_URL'),

  // CoinGecko API (optional)
  NEXT_PUBLIC_COINGECKO_API_KEY: getEnvVar('VITE_COINGECKO_API_KEY'),

  // Development/Build flags
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,
};
